/** Match MyCourses / course detail display normalization. */
export function collapseSpacesCourseName(s) {
  return String(s ?? '')
    .trim()
    .replace(/\s+/g, ' ');
}

/** Normalize `students.courses` from API (TEXT[], JSON string, or legacy shapes). */
export function normalizeStudentCourses(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw.map((c) => String(c).trim()).filter(Boolean);
  }
  if (typeof raw === 'string') {
    const s = raw.trim();
    if (!s) return [];
    try {
      const parsed = JSON.parse(s);
      if (Array.isArray(parsed)) {
        return parsed.map((c) => String(c).trim()).filter(Boolean);
      }
    } catch {
      /* fall through */
    }
    if (s.startsWith('{') && s.endsWith('}')) {
      return s
        .slice(1, -1)
        .split(',')
        .map((t) => t.replace(/^"|"$/g, '').trim())
        .filter(Boolean);
    }
    return [s];
  }
  return [];
}

/** Case-insensitive match against normalized course names on the student profile. */
export function studentHasCourseName(user, courseName) {
  const target = collapseSpacesCourseName(courseName).toLowerCase();
  if (!target) return false;
  return normalizeStudentCourses(user?.courses).some(
    (c) => collapseSpacesCourseName(c).toLowerCase() === target
  );
}
